/**
 * Created by gmogas on 15/12/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('bricks', {
                parent: 'app',
                url: '/bricks',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP'],
                    pageTitle: 'sigmaCrmApp.pharmacies.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/bricks/bricks.html',
                        controller: 'BricksController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
